.column {
	flex: 1 0 auto;
	height: 100%;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	/* stylelint-disable-next-line design-system/no-unsafe-design-token-usage */
	background-color: var(--ds-surface);
}

/* this one ensures proper size (in sync with header) */
.column:not(:last-child) {
	border-right: 1px solid var(--ds-border, var(--adg3-color-N50));
}

/* and this one makes border actually visible */
.column:not(:last-child) .list {
	border-right: 1px solid var(--ds-border, var(--adg3-color-N50));
}

.cell {
	position: relative;
	height: 40px;
	vertical-align: middle;
	background-color: var(--ds-surface, var(--adg3-color-N0));
}

.cell-optimized {
	background-color: transparent;
}

.cell-even {
	background-color: var(--ds-background-neutral, var(--adg3-color-N20));
}

.cell-even-optimized {
	background-color: var(--ds-background-neutral-subtle, var(--adg3-color-N20-transparent));
}

.issues-without-parent-section {
	margin-top: 16px;
	padding-top: 40px;
}

.issues-group-section {
	padding-top: 40px;
}

.blankRow {
	background-color: var(--ds-surface, var(--adg3-color-N0));
}

.groupRow {
	background-color: var(--ds-surface, var(--adg3-color-N0));
	box-shadow: 0 -2px var(--ds-border, var(--adg3-color-N40)); /* This box-shadow here works as border */
}

.space {
	flex: 1 1 auto;
	background-color: var(--ds-surface, var(--adg3-color-N0));
}
